
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/home_page2",
      function () {
        return require("private-next-pages/home_page2.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/home_page2"])
      });
    }
  